module.exports = __webpack_public_path__ + "img/loading.e6675d85.gif";